export const JSON_ONE = {
   
    "userId": "viraj808",
    "password": "xxxx"
    }



